/**
 * `GlobalScopes` in `O3_core` covers only the five CRUD scopes. The ticket
 * workflow adds four more, so they live here rather than widening the shared
 * core enum for one feature library.
 */
export enum SupportScopes {
  Triage = 'Triage',
  Escalate = 'Escalate',
  Resolve = 'Resolve',
  Close = 'Close',
  /** Queues a test email. Its own scope server-side, not an alias of Update. */
  Test = 'Test',
}
